module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-24.065d6fae.svg";